import { logEvent } from "@/App/service/analyticsService";
import { setClientForDestination } from "@/App/utils/whitelabel";
import { LinkProps } from "capitalrx-components-2.0/lib/general";
import { FC, PropsWithChildren, useCallback, useMemo } from "react";
import { useSearchParams } from "react-router";
import { ThemedLink } from "../themed/Link";

type ClientAwareLinkProps = LinkProps &
  PropsWithChildren & {
    readonly analyticsEvent?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    readonly analyticsParams?: any;
  };

export const ClientAwareLink: FC<ClientAwareLinkProps> = (props) => {
  const [searchParams] = useSearchParams();
  const { children, analyticsEvent, analyticsParams } = props;

  const linkClicked = useCallback(() => {
    if (analyticsEvent) {
      if (analyticsParams) {
        logEvent(analyticsEvent, analyticsParams);
      } else {
        logEvent(analyticsEvent);
      }
    }
  }, [analyticsEvent, analyticsParams]);

  const clientAwareDestination = useMemo(() => {
    const client = searchParams.get("client");
    return setClientForDestination(client, props.to);
  }, [props.to, searchParams]);

  const clientAwareLinkProps = useMemo((): LinkProps => {
    const interpolatedProps = {
      ...props,
      to: clientAwareDestination,
    };
    if (interpolatedProps["children"]) {
      delete interpolatedProps["children"];
    }
    if (interpolatedProps["analyticsEvent"]) {
      delete interpolatedProps["analyticsEvent"];
    }
    if (interpolatedProps["analyticsParams"]) {
      delete interpolatedProps["analyticsParams"];
    }
    return interpolatedProps;
  }, [clientAwareDestination, props]);

  return (
    <ThemedLink {...clientAwareLinkProps} onClick={linkClicked}>
      {children}
    </ThemedLink>
  );
};
